// Main entry: the production View. Sim wrappers live under ./sim and are
// never imported here, so a production import can't pull in fixtures.
export { AmbientIllustration } from "./AmbientIllustration";
export type { AmbientIllustrationProps, AmbientMotion } from "./AmbientIllustration";
